import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { coreService } from 'network-utils';
import { InnerTable, Avatar, Icon, TableData } from 'learning-panel-components';
import { useGetChallengeUsersLeaderboard } from '@queries/core/challenges';
import { selectToken } from '@redux/slices/userSlice';
import { UserData } from './userLeaderboard/userLeaderboard';
import styles from './innerTableContainer.module.scss';

const InnerTableContainer: FC<{ isOpen: boolean; teamUuid: string; challengeUuid?: string }> = ({
    isOpen,
    teamUuid,
    challengeUuid
}: {
    isOpen: boolean;
    teamUuid: string;
    challengeUuid?: string;
}) => {
    const token = useSelector(selectToken);
    const [allUsers, setAllUsers] = useState<TableData[][]>([]);
    const { data, isLoading } = useGetChallengeUsersLeaderboard(token, false, challengeUuid, teamUuid);

    const getRow = (row: UserData) => {
        const rankElement = <div>{`#${row.rank}`}</div>;
        const nameElement = (
            <div className={styles.name}>
                <Avatar name={row.nickname} avatarSrc={row.profilePicture} />
                <div className={styles.text}>{row.nickname}</div>
            </div>
        );
        const scoreElement = (
            <div className={styles.score}>
                <Icon name="devCoin" className={styles['dev-coin']} />
                <div>{row.score.toLocaleString()}</div>
            </div>
        );
        return [rankElement, nameElement, scoreElement];
    };

    useEffect(() => {
        if (!data) return;
        const users = data.usersLeaderboard.topTen.map((user: coreService.UserLeaderboard) =>
            getRow({
                rank: user.rank,
                nickname: user.nicknameOrEmail,
                score: Number(user.points),
                profilePicture: user.profilePicture
            })
        );
        setAllUsers(users);
    }, [data]);

    return (
        <InnerTable
            isLoading={isLoading}
            isOpen={isOpen}
            innerRows={allUsers}
            hasMoreRows={false}
            loadMoreRows={() => undefined}
        />
    );
};

export default InnerTableContainer;
